import { TextField } from "@mui/material";

export default function TextInput(props) {
  return <TextField data-input-text="text-input-form" {...props}/>;
}
